export default __webpack_public_path__ + "static/general-footer-image-78db76ae746fb8bb6c0df83c42c31dc7.jpg";